<template>
  <f7-page
    data-tour-id="samples-list-page-root"
    @page:beforein="handlePageBeforeIn"
  >
    <!-- LOADER BONITO NO BLOQUEANTE -->
    <div v-if="loading" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader />
        <div class="preloader-text">{{ $t('loading') }}</div>
      </div>
    </div>
    <div v-if="loaded">
      <div
        class="custom-table-container tableContainer"
        data-tour-id="samples-list-table-container"
      >
        <SamplesList
          ref="samplesList"
          :store="invoice"
          :forced-statuses="requestedInvoiceStatuses"
        />
      </div>
      <div
        class="content-setting display-flex justify-content-flex-start margin-top gap"
      ></div>
    </div>
    <!-- <div class="notificacionDeliv justify-content-center">
      <NotificationPrices v-if="priceAlert" id="notificationPrices" />
    </div> -->
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SamplesList from '@/components/SamplesRegister/SamplesList/SamplesList.vue';
import {
  NOTIFY_TIME_LONG,
  SAMPLES_REGISTER_GUIDED_TOUR_AUTO_START_DELAY,
} from '@/js/constants';
import {
  consumePendingSamplesRegisterInvoiceListTourStart,
  startSamplesRegisterInvoiceListGuidedTour,
  stopSamplesRegisterGuidedTour,
} from '@/services/samplesRegisterGuidedTour';
// import NotificationPrices from '@/components/NotificationPrices/index.vue';

export default {
  components: {
    SamplesList,
    // NotificationPrices,
  },
  data() {
    return {
      customStore: '',
      loading: false,
      loaded: false,
      guidedTourStartTimeoutId: null,
      isFetchingInvoices: false,
    };
  },
  computed: {
    requestedInvoiceStatuses() {
      const rawStatuses =
        this.$f7route?.query?.invoiceStatuses ||
        this.$route?.query?.invoiceStatuses ||
        '';

      return rawStatuses
        .split(',')
        .map((status) => status.trim())
        .filter(Boolean);
    },
    urlName() {
      if (this.lastRouteGeotoolboxSamples) {
        return 'GisActionsPage';
      }
      return this.lastRouteHome ? 'Home' : 'Home';
    },
    ...mapState('samples', [
      'lastRouteHome',
      'lastRouteGeotoolboxSamples',
    ]),
    company() {
      return this.$store.state.contact.company;
    },
    ...mapState('samplesRegisterModule', [
      'invoice',
      'invoiceSamples',
      'priceAlert',
    ]),
  },
  async mounted() {
    await this.refreshInvoices();
  },
  beforeDestroy() {
    this.clearSamplesGuidedTourStartTimeout();
    stopSamplesRegisterGuidedTour(this);
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('SamplesList.orderList'),
        disabled: false,
        page: 'SamplesList',
        active: true,
      },
    ]);
  },
  methods: {
    buildInvoiceStatusFilter() {
      if (!this.requestedInvoiceStatuses.length) {
        return undefined;
      }

      return `${this.requestedInvoiceStatuses.join(',')}/`;
    },
    async refreshInvoices() {
      if (this.isFetchingInvoices) return;

      try {
        this.isFetchingInvoices = true;
        this.loaded = false;
        this.loading = true;
        await this.fetchAlbaranes(this.buildInvoiceStatusFilter());
        this.loaded = true;
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.loading = false;
        this.isFetchingInvoices = false;
      }
    },
    async handlePageBeforeIn() {
      await this.refreshInvoices();
    },
    clearSamplesGuidedTourStartTimeout() {
      if (this.guidedTourStartTimeoutId) {
        clearTimeout(this.guidedTourStartTimeoutId);
        this.guidedTourStartTimeoutId = null;
      }
    },
    scheduleSamplesGuidedTourStart({ force = false } = {}) {
      if (!this.loaded) return;
      const shouldContinueFromRegister =
        force || consumePendingSamplesRegisterInvoiceListTourStart();
      if (!shouldContinueFromRegister) {
        return;
      }

      this.clearSamplesGuidedTourStartTimeout();
      this.guidedTourStartTimeoutId = setTimeout(() => {
        this.guidedTourStartTimeoutId = null;
        startSamplesRegisterInvoiceListGuidedTour(this, {
          force: true,
        });
      }, SAMPLES_REGISTER_GUIDED_TOUR_AUTO_START_DELAY);
    },
    async openTourInvoiceDetail(options = {}) {
      return (
        (await this.$refs.samplesList?.openTourInvoiceDetail?.(
          options
        )) || { opened: false, isInTransit: false }
      );
    },
    async GoSampleRegister() {
      try {
        if (this.invoiceSamples.length > 0) {
          this.setInvoiceSamples([]);
        }
        await this.RegisterInvoice();
        this.$f7router.navigate(
          {
            name: 'SamplesRegister',
          },
          {
            animate: true,
            transition: 'f7-fade',
          }
        );
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      }
    },
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('samplesRegisterModule', [
      'fetchAlbaranes',
      'RegisterInvoice',
      'resetData',
      'setInvoiceSamples',
    ]),
  },
  watch: {
    loaded(value) {
      if (value) {
        this.scheduleSamplesGuidedTourStart();
      }
    },
    async company(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchAlbaranes(this.buildInvoiceStatusFilter());
      }
    },
  },
};
</script>
<style scoped>
.tableContainer {
  border-radius: 8px;
  box-shadow: 0 2px 5px #00346a;
}
.notificacionDeliv {
  width: 70%;
}
</style>
